import InlinePreviewsFull from './components/InlinePreviewsFull';
import * as React from 'react';
import isInlinePreviewsOptionDirty from './utils/isInlinePreviewsOptionDirty';
import saveInlinePreviewsOption from './actions/saveInlinePreviewsOption';
import discardInlinePreviewsOption from './actions/discardInlinePreviewsOption';
import { getUserConfiguration } from 'owa-session-store';
var InlinePreviewsOption = {
    key: 'inlinePreviews',
    titleStringKey: 'optionTitle_inlinePreviews',
    searchTermsStringKey: 'optionTitle_inlinePreviews',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InlinePreviewsFull, null); },
        isDirty: isInlinePreviewsOptionDirty,
        onSave: saveInlinePreviewsOption,
        onDiscard: discardInlinePreviewsOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () { return getUserConfiguration().UserOptions.ShowInlinePreviews; },
            onToggle: saveInlinePreviewsOption,
        },
        order: 7 /* InlinePreview */,
        workloads: 1 /* Mail */,
        customTitle: 'options_inlinePreviews_quick_setting_label',
    },
};
export default InlinePreviewsOption;
//# sourceMappingURL=InlinePreviewsOption.js.map